import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import { getToolPartOutputRecord } from "./bedrock-shared";

export function getSitesListDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const sites = Array.isArray(outputRecord?.sites) ? outputRecord.sites : null;
  if (!sites) {
    return null;
  }

  if (sites.length === 0) {
    return "and found none";
  }

  return `and found ${sites.length === 1 ? "1 site" : `${sites.length} sites`}`;
}
